export const completeEmailSigninPage = () =>
  import("./EmailSignInPage").then((m) => ({ Component: m.EmailSignInPage }));
